module.exports = __webpack_public_path__ + "img/cr1_4.7ef07154.png";